<template>
  <VModal @close="$emit('close')">
    <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-lg sm:w-full">
      <OrderItemDetails v-if="!loading" :order-item="orderItem" />
      <div class="px-6 py-4 border-t">
        <BaseButton primary @click="$emit('close')"> Close </BaseButton>
      </div>
    </div>
  </VModal>
</template>

<script>
import OrderItemDetails from './order-item-details.vue';

export default {
  components: { OrderItemDetails },
  props: {
    orderItemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    orderItem() {
      return this.$store.state.entities.orderItems.byId[this.orderItemId];
    },
  },
  created() {
    this.fetchOrderItem();
  },
  methods: {
    setLoading(loading = true) {
      this.loading = loading;
    },
    async fetchOrderItem() {
      try {
        this.setLoading();
        await this.$store.dispatch('ui/orderItems/read', {
          orderItemUuid: this.orderItemId,
          params: {
            include: 'notes,media,links',
          },
        });
      } catch (error) {
        // something went wrong
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
